import styles from "./text.module.scss";

export const BasicText = ({
  direction = "horizontal",
  backgroundColor = "#fafafa",
  emoji = "",
  title = "",
  desc = "",
  textAlign = "center",
  style = {},
}: {
  direction?: "horizontal" | "vertical";
  backgroundColor?: string;
  emoji?: string | React.ReactNode;
  title?: string | React.ReactNode;
  desc?: string | React.ReactNode;
  textAlign?: "center" | "left" | "right";
  style?: React.CSSProperties;
}) => {
  return (
    <>
      <div
        className={`${styles["text"]} ${styles["basic"]} ${styles[direction]} ${styles[textAlign]}`}
        style={{
          ...style,
          backgroundColor: backgroundColor,
        }}
      >
        <div className={styles["text-item"]}>
          <div className={styles["text-contents"]}>
            {emoji && <div className={styles["text-emoji"]}>{emoji}</div>}
            {title && <h3 className={styles["text-title"]}>{title}</h3>}
            {desc && <p className={styles["text-desc"]}>{desc}</p>}
          </div>
        </div>
      </div>
    </>
  );
};
